module.exports = __webpack_public_path__ + "media/images/no_content.icon.removed-d49955e0.svg";